import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import { AdminLayout } from './components/AdminLayout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ASDAssessmentPage from './pages/ASDAssessmentPage';
import ADHDAssessmentPage from './pages/ADHDAssessmentPage';
import TherapyPage from './pages/TherapyPage';
import ContactPage from './pages/ContactPage';
import ThankYouPage from './pages/ThankYouPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import NewAssessmentsPage from './pages/NewAssessmentsPage';
import CalendarPage from './pages/CalendarPage';
import PaymentPlansPage from './pages/PaymentPlansPage';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Admin routes - login (no layout) */}
          <Route path="/admin-login" element={<AdminLoginPage />} />
          
          {/* Admin routes - with sidebar layout */}
          <Route path="/admin" element={<AdminLayout><AdminDashboardPage /></AdminLayout>} />
          <Route path="/admin/new-assessments" element={<AdminLayout><NewAssessmentsPage /></AdminLayout>} />
          <Route path="/admin/calendar" element={<AdminLayout><CalendarPage /></AdminLayout>} />
          <Route path="/admin/payment-plans" element={<AdminLayout><PaymentPlansPage /></AdminLayout>} />
          
          {/* Public routes - with layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/asd-assessment" element={<Layout><ASDAssessmentPage /></Layout>} />
          <Route path="/adhd-assessment" element={<Layout><ADHDAssessmentPage /></Layout>} />
          <Route path="/therapy" element={<Layout><TherapyPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/thank-you" element={<Layout><ThankYouPage /></Layout>} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;